import $http from '@/libs/axios'

export default class AdminPlansApi {
  static async delete(id: number) {
    return (await $http.delete(`admin/packages/${id}`)).data
  }

  static async update(data: any, id?: number) {
    let url = 'admin/packages/process'
    if (id) url += `/${id}`
    return (await $http.post(url, data)).data
  }
}
